import React from "react";
import Image from "next/image";
import { Grid, Typography } from "@mui/material";
import { getImage } from "../utils/strapi";

interface StoryGridProps {
  item: {
    title: string;
    description: string;
    image: string;
  };
}

export default (props: StoryGridProps) => {
  const image = getImage(props.item);
  return (
    <Grid
      container
      direction="row"
      alignContent="center"
      justifyContent="space-between"
      padding={5}
      marginBottom={10}
    >
      <Grid item xs={12} sm={11} md={5}>
        <Image
          width="100%"
          height="80%"
          layout="responsive"
          src={image.url}
          objectFit="cover"
        />
      </Grid>
      <Grid
        item
        container
        alignContent="center"
        xs={12}
        sm={11}
        md={6}
        margin={2}
      >
        <Grid item paddingBottom={2}>
          <Typography variant="h3">{props.item.title}</Typography>
        </Grid>
        <Grid item>
          <Typography variant="subtitle2">{props.item.description}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
